import { mediaData } from "@/mocks/homeData";

export default function MediaSection() {
  return (
    <section id="media" className="py-14 md:py-20 bg-background-100">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <h2 className="text-xl md:text-3xl font-heading text-foreground-50 text-center mb-2">精彩推荐</h2>
        <p className="text-foreground-500 text-sm text-center mb-8 md:mb-10">精选影视资讯与深度内容推荐</p>
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 md:gap-5">
          {mediaData.map((item) => (
            <article
              key={item.title}
              className="group bg-background-50 rounded-lg overflow-hidden border border-background-200/50 hover:border-primary-500/30 transition-all duration-300 cursor-pointer"
            >
              <div className="relative aspect-video overflow-hidden">
                <img
                  src={item.image}
                  alt={item.title}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500 object-top"
                  onError={(e) => {
                    (e.currentTarget.parentElement as HTMLElement).style.display = "none";
                  }}
                />
                <div className="absolute inset-0 flex items-center justify-center">
                  <span className="w-12 h-12 flex items-center justify-center rounded-full bg-background-950/70 text-primary-500 group-hover:bg-primary-500 group-hover:text-background-950 transition-colors">
                    <i className="ri-play-fill text-2xl ml-0.5"></i>
                  </span>
                </div>
                <div className="absolute bottom-2 right-2 px-2 py-0.5 bg-background-950/80 text-foreground-200 text-xs rounded whitespace-nowrap">
                  {item.duration}
                </div>
              </div>
              <div className="p-3 md:p-4">
                <h3 className="text-foreground-200 text-sm font-medium mb-1 line-clamp-1">{item.title}</h3>
                <p className="text-foreground-600 text-xs mb-2">{item.subtitle}</p>
                <span className="text-foreground-700 text-xs flex items-center gap-1">
                  <span className="w-3.5 h-3.5 flex items-center justify-center">
                    <i className="ri-eye-line text-[10px]"></i>
                  </span>
                  {item.views} 次观看
                </span>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}